import React from 'react';
import './index.less';
import classnames from 'classnames';
import { Upload, Modal } from 'antd';
import ABSIcon from '../../ABSIcon';
import ABSMessage from '../../ABSMessage';
import { GlobalApi } from '../../../abs/config/api';
import { IABSUploadImageProps } from '../interface';
import commonUtils from '../../../utils/commonUtils';

export default class Image extends React.Component<IABSUploadImageProps, any> {
  static defaultProps = {
    action: GlobalApi.uploadImgUrl,
    withCredentials: false,
    fileList: [],
    showRemoveIcon: true,
    showPreviewIcon: true
  };

  state = {
    previewVisible: false,
    previewImage: '',
    fileList: []
  };

  isCanUpload = true;

  componentDidMount() {
    const { fileList = [], resetResult } = this.props;
    this.setState({ fileList });
    if (resetResult) {
      resetResult();
    }
  }

  componentWillReceiveProps(nextProps: IABSUploadImageProps) {
    if (!commonUtils.isEqual(nextProps.fileList, this.props.fileList)) {
      this.setState({ fileList: nextProps.fileList ? nextProps.fileList : [] });
      if (nextProps.resetResult) {
        nextProps.resetResult();
      }
    }
  }

  renderUploadButton() {
    const { iconText } = this.props;
    return (
      <div>
        <ABSIcon isAnt={true} type="plus" />
        {iconText ? <div className="ant-upload-text abs-upload-text">{iconText}</div> : null}
      </div>
    );
  }

  render() {
    const { previewVisible, previewImage, fileList } = this.state;
    const { action, withCredentials, showRemoveIcon, showPreviewIcon, result } = this.props;
    const claszs = classnames('abs-upload-image', { 'has-error': !result.pass });
    const list = fileList ? fileList : [];
    return (
      <div className={claszs}>
        <Upload
          action={action}
          listType="picture-card"
          fileList={list}
          accept="image/*"
          onRemove={this.onRemove}
          withCredentials={withCredentials}
          showUploadList={{ showRemoveIcon, showPreviewIcon }}
          onPreview={this.onPreview}
          onChange={this.onChange}
          beforeUpload={this.onBeforeUpload}
        >
          {list.length >= 1 ? null : this.renderUploadButton()}
        </Upload>
        <Modal wrapClassName="abs-upload-image-modal" visible={previewVisible} footer={null} onCancel={this.onCancel}>
          <img alt="example" style={{ width: '100%' }} src={previewImage} />
        </Modal>
      </div>
    );
  }

  reset = () => {
    const { fileList = [] } = this.props;
    this.setState({ fileList });
  };

  getValue = () => {
    const { fileList } = this.state;
    // tslint:disable-next-line:no-shadowed-variable
    const fileCodeList: any[] = fileList.map((item: any) => {
      if (item.status === 'done' && item.response) {
        return { uid: item.uid, code: item.response[0].FileCode, name: item.name };
      }
      if (item.status === 'done' && item.code) {
        return { uid: item.uid, code: item.code, name: item.name };
      }
      return;
    });
    return fileCodeList.filter(item => item !== undefined);
  };

  onBeforeUpload = file => {
    const isJPG = file.type === 'image/jpeg' || file.type === 'image/jpg' || file.type === 'image/png';
    if (!isJPG) {
      ABSMessage.error('您上传的文件格式不对，请上传图片格式!');
      return false;
    }
    const { limitSize } = this.props;
    if (limitSize) {
      const isLimit = file.size / 1024 / 1024 < limitSize;
      if (!isLimit) {
        this.isCanUpload = false;
        ABSMessage.error(`图片的大小不超过${limitSize}MB!`);
        return false;
      }
    }
    this.isCanUpload = true;
    return true;
  };

  onCancel = () => this.setState({ previewVisible: false });

  onPreview = file => {
    this.setState({
      previewImage: file.url || file.thumbUrl,
      previewVisible: true
    });
  };

  onChange = response => {
    if (!this.isCanUpload) {
      return;
    }
    let { file, fileList } = response;
    const { updateFileCode } = this.props;
    if (file.status === 'done' && updateFileCode) {
      const { data } = file.response ? file.response : '';
      let res = data && data.data ? data.data : '';
      if (!res) {
        res = file.response[0].FileCode;
      }
      if (updateFileCode) {
        updateFileCode(res, fileList);
      }
    } else if (file.status === 'error') {
      ABSMessage.error(`${file.name}上传失败！`);
      fileList = [];
    }
    this.setState({ fileList });
    this.onValidator(fileList);
  };

  onRemove = file => {
    this.setState(state => {
      const index = state.fileList.indexOf(file);
      const newFileList = state.fileList.slice();
      newFileList.splice(index, 1);
      this.onValidator(newFileList);
      return {
        fileList: newFileList
      };
    });
    const { onRemove } = this.props;
    if (onRemove) {
      onRemove();
    }
  };

  onRefresh = () => {
    this.setState({ fileList: [] });
  };

  onValidator = data => {
    const { onValidator } = this.props;
    if (onValidator) {
      onValidator(data);
    }
  };
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/ABSUpload/Image/index.tsx